import React from 'react';

import CSSModules from 'react-css-modules';

import {unicodeToEmojiUrl} from '../../../utils/emojiUtils';
import {CANVAS_RATIO} from '../../Canvas';
import type {BaseObject, CanvasSize} from '../../types';

import styles from '../styles.module.scss';

export const INITIAL_EMOJI_OBJECT_STYLES = {
  x: 3.6,
  y: 7,
  scale: 1,
  rotate: 0,
};

interface EmojiObjectProps<T extends BaseObject> {
  object: Extract<T, {type: 'emoji'}>;
  canvasSize: CanvasSize;
}

export const EmojiObjectComponent = <T extends BaseObject>({
  object,
  canvasSize,
}: EmojiObjectProps<T>) => {
  const {width, height} = canvasSize;

  // Guides store emojis under the key 'text', however in Lessons we want to localise text strings but not emojis and so we store them under their own key
  const emoji = object.code ?? object.text;

  if (!emoji) {
    return null;
  }

  return (
    <span
      styleName='emoji'
      style={{
        width: (width * 2) / CANVAS_RATIO.width,
        height: (height * 2) / CANVAS_RATIO.height,
        display: 'flex',
      }}
    >
      <img
        draggable='false'
        src={unicodeToEmojiUrl(emoji)}
        alt=''
        data-automation='emoji'
      />
    </span>
  );
};

export const EmojiObject = CSSModules(EmojiObjectComponent, styles);
